import { DEFAULT_LANGUAGE, DEFAULT_NAMESPACE } from '../constants';
function loadTranslations(translation, translations, primaryLanguage, namespace = DEFAULT_NAMESPACE) {
  const shouldLoadTranslations = language => language === DEFAULT_LANGUAGE || language === primaryLanguage;
  Object.entries(translations).forEach(([language, items]) => {
    if (!shouldLoadTranslations(language)) return;
    translation.addResourceBundle(language, namespace, items);
  });
}
export default loadTranslations;
//# sourceMappingURL=load-translations.js.map